import { defineComponent as L, useSlots as W, computed as t, createBlock as u, openBlock as s, unref as c, withCtx as z, createElementVNode as y, normalizeClass as d, createElementBlock as f, createCommentVNode as r, renderSlot as C, mergeProps as w, resolveDynamicComponent as G, toRaw as H } from "vue";
import { RevIllustration as M } from "@ds/components/Illustration";
import { RevRadioBase as U } from "@ds/components/RadioBase";
import { RevTag as q } from "@ds/components/Tag";
import { usePropsValidation as F } from "../../composables/usePropsValidation.js";
import { isString as m } from "../../utils/isString.js";
import { isValidNumber as V } from "../../utils/isValidNumber.js";
import { tw as a } from "../../utils/tailwind.js";
import { RADIO_CLASS_NAMES as v, CHANGE_EVENT as J } from "./Radio.constant.js";
const K = ["for"], ie = /* @__PURE__ */ L({
  name: "RevRadio",
  __name: "Radio",
  props: {
    modelValue: { type: [Boolean, String] },
    disabled: { type: Boolean, default: !1 },
    displayDescriptionOnlyWhenChecked: { type: Boolean, default: !1 },
    id: {},
    image: { default: void 0 },
    tagProps: { default: void 0 },
    imageProps: { default: void 0 },
    value: {},
    variant: { default: "default" }
  },
  emits: ["change", "update:modelValue"],
  setup(o, { emit: N }) {
    const e = o, p = W(), b = N, x = t(() => p.label ? e.variant !== "imageOnly" : !1), R = t(() => p.description ? e.variant === "full" : !1), h = t(
      () => !!e.tagProps && e.variant === "full"
    ), n = t({
      get() {
        return typeof e.modelValue == "string" ? e.modelValue === e.value : e.modelValue;
      },
      set(l) {
        l !== e.modelValue && b("update:modelValue", l);
      }
    });
    function O(l) {
      b(J, l);
    }
    const i = t(() => {
      const l = e.imageProps || {};
      return {
        ...l,
        height: V(l.height) ? l.height : 24,
        width: V(l.width) ? l.width : 24,
        src: m(e.image) ? e.image : void 0,
        alt: m(l.alt) ? l.alt : void 0
      };
    }), P = t(() => e.variant !== "default" && m(i.value.alt));
    F({
      "Radio: image must have an alt text when using the ImageOnly variant.": () => e.variant === "imageOnly" && !i.value.alt
    });
    function g(l) {
      return m(l);
    }
    const A = t(() => typeof e.image == "object"), B = t(() => [
      a`text-static-default-low body-2 ml-32 pt-8`,
      e.displayDescriptionOnlyWhenChecked && !n.value && a`hidden`,
      e.disabled && a`text-static-default-low-disabled`,
      v
    ]), D = t(() => [
      v,
      a`peer body-1 block`,
      e.variant !== "default" && a`rounded-sm box-border border p-16 peer-focus-visible:outline-default-hi`,
      e.variant === "full" && a`min-h-56`,
      !e.disabled && n.value && a`border-action-default-low-pressed`,
      !e.disabled && !n.value && a`border-action-default-low`,
      !e.disabled && e.variant !== "default" && a`bg-static-default-low hover:bg-static-default-low-hover`,
      !e.disabled && a`text-action-default-hi cursor-pointer`,
      e.disabled && e.variant !== "default" && a`bg-static-default-low-disabled border-action-default-low-disabled`,
      e.disabled && a`text-action-default-hi-disabled cursor-not-allowed`,
      h.value && a`relative`
    ]), S = t(() => [
      e.variant === "default" && a`left-0 top-2 peer-focus-visible:outline-default-hi`,
      e.variant === "full" && a`left-16 top-18`,
      e.variant === "imageOnly" && a`left-16 top-1/2 -mt-10`
    ]), E = t(() => [
      e.variant === "default" && a`left-6 top-8`,
      e.variant === "full" && a`left-22 top-24`,
      e.variant === "imageOnly" && a`left-22 top-1/2 -mt-4`
    ]), I = a`ml-32 flex`, T = a`flex-1 ${v}`, $ = t(() => [
      a`flex max-h-24 items-center`,
      e.variant === "full" && a`ml-16`,
      e.disabled && a`opacity-50`
    ]);
    return (l, k) => (s(), u(c(U), {
      id: o.id,
      "checkmark-class-names": S.value,
      "checkmark-tick-class-names": E.value,
      disabled: o.disabled,
      label: "",
      "model-value": n.value,
      value: o.value,
      onChange: O,
      "onUpdate:modelValue": k[0] || (k[0] = (j) => n.value = j)
    }, {
      default: z(() => [
        y("label", {
          class: d(D.value),
          for: o.id
        }, [
          y("div", {
            class: d(I)
          }, [
            x.value ? (s(), f("div", {
              key: 0,
              class: d(T)
            }, [
              C(l.$slots, "label")
            ])) : r("", !0),
            P.value ? (s(), f("div", {
              key: 1,
              class: d($.value)
            }, [
              g(i.value.src) && g(i.value.alt) ? (s(), u(c(M), w({ key: 0 }, i.value, {
                alt: i.value.alt,
                src: i.value.src
              }), null, 16, ["alt", "src"])) : r("", !0),
              A.value ? (s(), u(G(H(o.image)), {
                key: 1,
                "aria-label": i.value.alt,
                role: "img"
              }, null, 8, ["aria-label"])) : r("", !0)
            ], 2)) : r("", !0)
          ]),
          R.value ? (s(), f("div", {
            key: 0,
            class: d(B.value)
          }, [
            C(l.$slots, "description")
          ], 2)) : r("", !0),
          h.value ? (s(), u(c(q), w({ key: 1 }, o.tagProps, { class: "absolute -top-10 right-16" }), null, 16)) : r("", !0)
        ], 10, K)
      ]),
      _: 3
    }, 8, ["id", "checkmark-class-names", "checkmark-tick-class-names", "disabled", "model-value", "value"]));
  }
});
export {
  ie as default
};
